"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maybe = maybe;
exports.nullable = nullable;
exports.optional = optional;

var _debrief = require("debrief");

var _Result = require("lemons/Result");

var _constants = require("./constants");

var _either = require("./either");

/**
 * Builds a Decoder that returns Ok for either `undefined` or `T` values,
 * given a Decoder for `T`.  Err otherwise.
 */
function optional(decoder) {
  return (0, _either.either)(_constants.undefined_, decoder);
}
/**
 * Builds a Decoder that returns Ok for either `null` or `T` values,
 * given a Decoder for `T`.  Err otherwise.
 */


function nullable(decoder) {
  return (0, _either.either)(_constants.null_, decoder);
}
/**
 * Decoder that only returns Ok for `null` or `undefined` inputs.
 * This is effectively equivalent to either(null_, undefined_), but combines
 * their error message output into a single line for convenience.
 */


var undefined_or_null = function undefined_or_null(blob) {
  return blob === undefined || blob === null ? (0, _Result.Ok)(blob) : // Combine error message into a single line
  (0, _Result.Err)((0, _debrief.annotate)(blob, 'Must be undefined or null'));
};
/**
 * Decoder that only returns Ok for `null` or `undefined` inputs.
 */


function maybe(decoder) {
  return (0, _either.either)(undefined_or_null, decoder);
}